import { createContext, useState } from 'react'

const AccordionContainer = ({ children }: { children: any }) => {
  const [accordionIdx, setAccordionIdx] = useState(0)
  const [isSame, setIsSame] = useState(false)

  return (
    <AccordionContext.Provider value={[accordionIdx, setAccordionIdx]}>
      <IsSameContext.Provider value={[isSame, setIsSame]}>{children}</IsSameContext.Provider>
    </AccordionContext.Provider>
  )
}

export default AccordionContainer
export const AccordionContext = createContext([])
export const IsSameContext = createContext([])
